// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"004f142c","977":"f37de3ec"}[chunkId] + ".chunk.js";
};